import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AiService } from '../../services/ai.service';
import { HelpResponse } from '../../models/ai.model';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-ai-help-button',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ai-help-button.component.html',
})
export class AiHelpButtonComponent {
  private readonly aiService = inject(AiService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  get canView(): boolean    { return this.authService.hasAi('ai-help', 'canview'); }
  get canExecute(): boolean { return this.authService.hasAi('ai-help', 'canexecute'); }

  isOpen = false;
  question = '';
  loading = false;
  helpResponse: HelpResponse | null = null;
  error = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      this.question = '';
      this.helpResponse = null;
      this.error = false;
      this.loading = false;
    }
  }

  submit(): void {
    if (!this.question.trim() || this.loading || !this.canExecute) return;
    this.loading = true;
    this.error = false;
    this.helpResponse = null;

    this.aiService
      .getHelp(this.question.trim(), this.router.url, this.entityFromRoute())
      .subscribe({
        next: (res) => {
          this.helpResponse = res;
          this.loading = false;
        },
        error: () => {
          this.error = true;
          this.loading = false;
        },
      });
  }

  onLinkClick(link: string): void {
    this.router.navigateByUrl(link);
    this.isOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen) this.toggle();
  }

  private entityFromRoute(): string {
    const segments = this.router.url.split('?')[0].split('/').filter(Boolean);
    return segments[segments.length - 1] ?? '';
  }
}
